/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderReceiveAddressVo } from './OrderReceiveAddressVo';
import {
    OrderReceiveAddressVoFromJSON,
    OrderReceiveAddressVoFromJSONTyped,
    OrderReceiveAddressVoToJSON,
    OrderReceiveAddressVoToJSONTyped,
} from './OrderReceiveAddressVo';
import type { OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo } from './OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo';
import {
    OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoFromJSON,
    OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoFromJSONTyped,
    OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoToJSON,
    OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoToJSONTyped,
} from './OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo';
import type { OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo } from './OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo';
import {
    OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoFromJSON,
    OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoFromJSONTyped,
    OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoToJSON,
    OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoToJSONTyped,
} from './OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo';

/**
 * 
 * @export
 * @interface OrderInfoForSimpleFromRocketVo
 */
export interface OrderInfoForSimpleFromRocketVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    orderId?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    orderCode?: string;
    /**
     * 仓库ID
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    warehouseId?: number;
    /**
     * 仓库名称
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    warehouseName?: string;
    /**
     * 订单状态
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    orderStatus?: number;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    orderStatusName?: string;
    /**
     * 请求类型
     * @type {string}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    requestType?: string;
    /**
     * 快递件申请单ID
     * @type {number}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    orderSimpleRequisitionId?: number;
    /**
     * 商品列表
     * @type {Array<OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo>}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    goods?: Array<OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVo>;
    /**
     * 申请商品列表
     * @type {Array<OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo>}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    applyGoods?: Array<OrderInfoForSimpleFromRocketApplyGoodsForSimpleVo>;
    /**
     * 
     * @type {OrderReceiveAddressVo}
     * @memberof OrderInfoForSimpleFromRocketVo
     */
    receiveAddress?: OrderReceiveAddressVo;
}

/**
 * Check if a given object implements the OrderInfoForSimpleFromRocketVo interface.
 */
export function instanceOfOrderInfoForSimpleFromRocketVo(value: object): value is OrderInfoForSimpleFromRocketVo {
    return true;
}

export function OrderInfoForSimpleFromRocketVoFromJSON(json: any): OrderInfoForSimpleFromRocketVo {
    return OrderInfoForSimpleFromRocketVoFromJSONTyped(json, false);
}

export function OrderInfoForSimpleFromRocketVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForSimpleFromRocketVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'orderSimpleRequisitionId': json['orderSimpleRequisitionId'] == null ? undefined : json['orderSimpleRequisitionId'],
        'goods': json['goods'] == null ? undefined : ((json['goods'] as Array<any>).map(OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoFromJSON)),
        'applyGoods': json['applyGoods'] == null ? undefined : ((json['applyGoods'] as Array<any>).map(OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoFromJSON)),
        'receiveAddress': json['receiveAddress'] == null ? undefined : OrderReceiveAddressVoFromJSON(json['receiveAddress']),
    };
}

export function OrderInfoForSimpleFromRocketVoToJSON(json: any): OrderInfoForSimpleFromRocketVo {
    return OrderInfoForSimpleFromRocketVoToJSONTyped(json, false);
}

export function OrderInfoForSimpleFromRocketVoToJSONTyped(value?: OrderInfoForSimpleFromRocketVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'orderStatus': value['orderStatus'],
        'orderStatusName': value['orderStatusName'],
        'requestType': value['requestType'],
        'orderSimpleRequisitionId': value['orderSimpleRequisitionId'],
        'goods': value['goods'] == null ? undefined : ((value['goods'] as Array<any>).map(OrderInfoForSimpleFromRocketGoodsInfoForSimpleFromRocketVoToJSON)),
        'applyGoods': value['applyGoods'] == null ? undefined : ((value['applyGoods'] as Array<any>).map(OrderInfoForSimpleFromRocketApplyGoodsForSimpleVoToJSON)),
        'receiveAddress': OrderReceiveAddressVoToJSON(value['receiveAddress']),
    };
}

